export default __webpack_public_path__ + "static/media/juego_responsable.78b7055c.svg";